.editorControls {
	height: 50%;
	padding-top: 14px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}

.save {
	width: 24px;
	height: 24px;
	border: none;
	background: none;
	cursor: pointer;
	padding: 0;

	&:hover:not(:disabled) {
		.saveIcon {
			ellipse {
				fill: $activeColor;
			}
		}
	}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;

		.saveIcon {
			ellipse {
				fill: $greyColor;
			}
		}
	}
}

.cancel {
	width: 24px;
	height: 24px;
	border: none;
	background: none;
	cursor: pointer;
	padding: 0;

	&:hover {
		.cancelIcon {
			circle {
				fill: $errorColor;
			}
		}
	}
}

.saveIcon {
	display: block;
	width: 100%;
	height: 100%;

	ellipse {
		fill: $hoverColor;
		transition: fill 0.25s cubic-bezier(0.4, 0, 0.2, 1);
	}
}

.cancelIcon {
	display: block;
	width: 100%;
	height: 100%;

	circle {
		fill: $errorColor2;
		transition: fill 0.25s cubic-bezier(0.4, 0, 0.2, 1);
	}
}
